<template>
    <div class="form-membership-plan-chip flex flex-row">
        <div data-dismissible="chip" @click="clearPlan()" class="relative mx-auto grid cursor-pointer select-none items-center whitespace-nowrap
                rounded-full border border-zinc-300 bg-zinc-100 px-3 py-1.5 text-sm font-medium tracking-tight text-zinc-800 hover:bg-white">
            <span class="mr-5">{{ selectedPlan.subscription_plan_name }}</span>
            <button data-dismissible-target="chip"
                    type="button"
                    class="!absolute right-1 top-2/4 mx-px h-5 max-h-[32px] w-5 max-w-[32px] -translate-y-2/4 select-none rounded-md
                                text-center align-middle font-sans text-xs font-medium uppercase text-black transition-all
                                hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            >
                <span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-4 w-4"
                         stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormMembershipPlanChip',
    props: {
        selectedPlan: {
            type: Object,
        },
        clearPlan: {
            type: Function,
        },
    },
    data () {
        return {
            plan: null,
        };
    },
    mounted: function () {
        this.plan = this.selectedPlan;
    },
};
</script>
